import { Ibox } from "components/Ibox";
import { Page } from "containers/Page";
import { Col, Row } from "react-bootstrap";
import { useProxy } from "../../Hooks/useProxy";
import { useEffect, useState } from "react";
import { ModalListaProxy } from "./containers/ModalListaProxy";
import { CadastroProxy } from "./containers/CadastroProxy";
import { ButtonRenovar } from "./style";

export function Proxy() {
  const { listar, dados, loading, renovarProxyScrape, renovarScrapeless } =
    useProxy();
  const [showModalProxy, setShowModalProxy] = useState<boolean>(false);

  function handleCloseModal() {
    setShowModalProxy(!showModalProxy);
  }
  useEffect(() => {
    listar();
  }, []);
  return (
    <Page lastPage="Home" title="Proxy">
      <div>
        <Row className="p-4">
          <Col md={3}>
            <a onClick={handleCloseModal} style={{ cursor: "pointer" }}>
              <Ibox className="d-flex align-items-center justify-content-center border-bottom p-w-sm">
                <h3>Proxy Ativos</h3>
                <h2 className="d-flex align-items-center justify-content-center border-bottom p-w-sm">
                  {dados.length}
                </h2>
              </Ibox>
            </a>
          </Col>
          <Col
            md={6}
            className="d-flex align-items-center gap-3"
          >
            <ButtonRenovar
              variante="primary"
              type="button"
              disabled={loading}
              onClick={() => renovarProxyScrape()}
            >
              {loading ? "Carregando" : "Renovar proxyscrape"}
            </ButtonRenovar>
            <ButtonRenovar
              variante="primary"
              type="button"
              disabled={loading}
              onClick={() => renovarScrapeless()}
            >
              {loading ? "Carregando" : "Renovar scrapeless"}
            </ButtonRenovar>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <CadastroProxy listarProxys={listar} />
            <div></div>
          </Col>
        </Row>
      </div>
      <ModalListaProxy
        show={showModalProxy}
        handleClose={handleCloseModal}
        totalRows={dados.length}
        dados={dados}
      
      />
    </Page>
  );
}
